import { Alert, Card, Skeleton } from "antd";

import { useState } from "react";

import HrText from "components/HrText/HrText";
import "./PrenotazioniInsolute.css";
import IPreventiviInsoluti from "pages/AreaRiservata/PrenotazioniInsolute/IPrenotazioniInsolute";
import { PagesEnum } from "types/PagesEnum";
import { formStep } from "types/StepEnums";
import { FaShoppingCart } from "react-icons/fa";
import _ from "lodash";
import { CustomButton } from "core/interfaces/components";
import { CustomButtonType } from "components/CustomButton/CustomButtonType";
import NavigationManager from "utils/NavigationManager";
import { Enhanced } from "utils/ReactUtils";

const PreventiviInsoluti: React.FC<IPreventiviInsoluti> = ({ preventivi ,t,sessionInfo}) => {
	
	const [loading] = useState<boolean>(false);

	
	const { GoToPage } = NavigationManager(sessionInfo);

	const onCardClick = (idPrev: number) => {
		GoToPage(PagesEnum.Payment, formStep.Pagamento, { idPreventivo: idPrev });
	};

	return (
		<>
			{loading ? (
				<Skeleton active />
			) : (
				<>
					<div id="prenotazioniUtente">
						{preventivi ? (
							<>
								<HrText text={t("Prenotazioni.title")} />
								{_.sortBy(preventivi, "IdPreventivo").map((res, index) => {
									return (
										<Card key={index} className="prenotazioni-card">
											<span className="prenotazioni-card-titles">
												{t("reservedArea.prenotazioniInsoluteUtente.cardTitle").format(
													res.DataPreventivo.toFormattedDateString("DD/MM/YYYY"),
													res.Nominativo,
													res.CodPai
												)}
											</span>
											<div className="prenotazioni-card-detils">
												{res.DettagliPreventivo.map((dett, ix) => {
													return (
														<div key={index + "/" + ix.toString()}>
															<span className="prenotazioni-card-item">
																<div className="activity"> {dett.Attivita} </div>
																<div className="date">
																	<span>{dett.Da.toFormattedDateString("DD/MM/YYYY")}</span>
																	&nbsp;
																	<span>
																		{dett.Da.toFormattedDateString("HH:mm")}-{dett.A.toFormattedDateString("HH:mm")}
																	</span>
																</div>
															</span>
														</div>
													);
												})}
												<hr style={{ width: "100%" }} />
												<div className="prenotazioni-card-totals">
													<span>{t("reservedArea.prenotazioniInsoluteUtente.importo")}</span>

													<span>
														{(res.ImportoScontatoConIva + res.Bollo).toLocaleString(
															undefined, // leave undefined to use the visitor's browser
															// locale or a string like 'en-US' to override it.
															{ style: "currency", currency: "EUR" }
														)}
													</span>
												</div>
											</div>
											<div className="prenotazioni-card-pay">
												<div>
													<CustomButton
														buttonType={CustomButtonType.positive}
														text={t("reservedArea.prenotazioniInsoluteUtente.PagaOra")}
														icon={<FaShoppingCart />}
														OnClick={() => onCardClick(res.IdPreventivo!)}
													></CustomButton>
												</div>
											</div>
										</Card>
									);
								})}
							</>
						) : (
							<Alert message={t("errorMessages.base")} type="error" showIcon banner />
						)}
					</div>
				</>
			)}
		</>
	);
};

export default Enhanced( PreventiviInsoluti,{componentNamespace:"PreventiviInsoluti"});
